export default __webpack_public_path__ + "static/362-3f08e887cbba84d760262641ed018300.gif";